window.addEventListener('load', function () {
	const form = document.getElementsById('shop-form');
	form.addEventListener('submit', function (event) {
		if (form.checkValidity() === false) {
			event.preventDefault();
			event.stopPropagation();
		}
		form.classList.add('was-validated');
	}, false);
}, false);
